module.exports = __webpack_public_path__ + "img/reference31.32e1768a.jpg";